import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=5d8f7969&scoped=true&"
import script from "./Registro.vue?vue&type=script&lang=js&"
export * from "./Registro.vue?vue&type=script&lang=js&"
import style0 from "./Registro.vue?vue&type=style&index=0&id=5d8f7969&prod&scoped=true&lang=css&"
import style1 from "./Registro.vue?vue&type=style&index=1&id=5d8f7969&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f7969",
  null
  
)

export default component.exports